import baseUrl from "./apiBaseUrl";
import { getStoredAuthIdentity, getStoredAuthToken } from "./authTokenStorage";
import {
  accessTokenNeedsRefresh, authenticationRecoveryError, recoverAuthentication, refreshAccessToken,
} from "./sessionCoordinator";

export default async function sessionFetch(url, options = {}) {
  if (typeof url !== "string" || !url.startsWith(baseUrl)) return global.fetch(url, options);
  const headers = { ...options.headers };
  const authorization = headers.Authorization || headers.authorization;
  if (!authorization || !authorization.startsWith("Bearer ")) return global.fetch(url, options);
  let token = authorization.slice(7);
  const identity = getStoredAuthIdentity();
  if (!token) {
    recoverAuthentication("required", identity);
    throw authenticationRecoveryError();
  }
  if (token !== getStoredAuthToken()) throw authenticationRecoveryError("Session changed");
  if (accessTokenNeedsRefresh(token)) token = await refreshAccessToken(token);
  const send = () => {
    if (getStoredAuthIdentity() !== identity) throw authenticationRecoveryError("Session changed");
    return global.fetch(url, { ...options, headers: { ...headers, Authorization: `Bearer ${token}` } });
  };
  let response = await send();
  if (getStoredAuthIdentity() !== identity) throw authenticationRecoveryError("Session changed");
  if (response.status === 401) {
    token = await refreshAccessToken(token);
    response = await send();
    if (getStoredAuthIdentity() !== identity) throw authenticationRecoveryError("Session changed");
    if (response.status === 401) {
      recoverAuthentication("required", identity);
      throw authenticationRecoveryError();
    }
  }
  return new Proxy(response, {
    get(target, key) {
      if (["json", "text"].includes(key) && typeof target[key] === "function") {
        return async (...args) => {
          const body = await target[key](...args);
          if (getStoredAuthIdentity() !== identity) throw authenticationRecoveryError("Session changed");
          return body;
        };
      }
      const value = Reflect.get(target, key, target);
      return typeof value === "function" ? value.bind(target) : value;
    },
  });
}
